import React from 'react';
import DtePdfModalLayout from './DtePdfModalLayout';
import PdfViewer from '../pdf/PdfViewer';

interface DtePdfModalProps {
  isOpen: boolean;
  onClose: () => void;
  base64Pdf?: string;
  /** Título opcional del modal */
  title?: string;
  /** Tamaños opcionales del contenedor */
  maxWidth?: string;   // ej. 'max-w-4xl'
  maxHeight?: string;  // ej. 'max-h-[85vh]'
  /** Cerrar al hacer click en backdrop */
  closeOnBackdrop?: boolean;
}

const DtePdfModal: React.FC<DtePdfModalProps> = ({
  isOpen,
  onClose,
  base64Pdf,
  title = 'Vista previa DTE',
  maxWidth,
  maxHeight,
  closeOnBackdrop,
}) => {
  return (
    <DtePdfModalLayout
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      closeOnBackdrop={closeOnBackdrop}
    >
      {base64Pdf ? (
        <PdfViewer base64Data={base64Pdf} />
      ) : (
        <div className="flex h-full w-full items-center justify-center text-sm text-gray-500 dark:text-gray-300">
          No hay documento DTE disponible
        </div>
      )}
    </DtePdfModalLayout>
  );
};

export default DtePdfModal;
